import { ListItemButton, ListItemIcon } from "@mui/material";
import Radio from "@mui/material/Radio";
import React from "react";
import ListItemText from "@mui/material/ListItemText";
import makeStyles from "@mui/styles/makeStyles";
import { alpha } from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    borderBottom: "1px solid " + theme.palette.primary.light,
    "&:first-child": {
      //borderTop: '1px solid ' + theme.palette.primary.light,
    },
    "&:last-child": {
      //borderTop: '1px solid ' + theme.palette.primary.light,
      borderBottom: "none",
    },
    "& .MuiListItemIcon-root": {
      minWidth: 0,
      marginRight: theme.spacing(1),
    },
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
  },
  selected: {
    backgroundColor: "red",
    "&.MuiListItem-root, &.MuiListItem-root:active, &.MuiListItem-root:hover":
      {
        backgroundColor: alpha(theme.palette.secondary.main, 0.2),
        //borderBottom: "1px solid " + alpha(theme.palette.secondary.main, 0.2),
      },
  },
  primary: {
    fontWeight: 500,
    fontSize: theme.clientType == "desktop" ? "20px" : "15px",
  },
  secondary: {
    fontSize: theme.clientType == "desktop" ? "15px" : "12px",
    color: "#232323",
  },
}));

export default ({
  selected,
  onClick,
  primaryText,
  secondaryText,
  action,
  disabled,
  labelId,
}) => {
  const classes = useStyles();

  return (
    <ListItemButton
      selected={selected}
      onClick={onClick}
      sx={(theme) => ({
        borderBottom: `1px solid ${theme.palette.primary.light}`,
        px: 3,

        "&:last-of-type": {
          borderBottom: "none",
        },

        "& .MuiListItemIcon-root": {
          minWidth: 0,
          mr: 1,
        },

        "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:active": {
          backgroundColor: alpha(theme.palette.secondary.main, 0.2),
          borderBottom: `1px solid ${alpha(
            theme.palette.secondary.main,
            0.2,
          )}`,
        },
      })}
      disabled={disabled}
    >
      <ListItemIcon>
        <Radio
          edge="start"
          checked={selected}
          inputProps={{ "aria-labelledby": labelId }}
          tabIndex={-1}
        />
      </ListItemIcon>
      <ListItemText
        id={labelId}
        classes={{ primary: classes.primary, secondary: classes.secondary }}
        primary={primaryText}
        secondary={secondaryText}
      />
      {action && action}
    </ListItemButton>
  );
};
